import { Elements } from "@stripe/react-stripe-js";
import { useState, useEffect } from "react";
import stripePromise from "../../../../pages/Billing/stripe";
import usePayment from "../../../../hooks/usePayment";
import CheckoutForm from "./CheckoutForm";
import { projectLogoLight } from "../../../../generalConfigs";
import { Link, useHistory } from "react-router-dom";
import { Modal, Spinner } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { BsShieldCheck } from "react-icons/bs";
import { eSubscriptionStatus } from "../../../../@types/Billing/Subscription";
import useSubscription from "../../../../hooks/useSubscription";
import FailedSubscription from "../../subscription/Failed";
import LoadingSubscription from "../../subscription/Loading";
import SuccessfullySubscription from "../../subscription/Sucessfully";
import { useCustomer } from "../../../../hooks/useCustomer";
import useBillingContext, {
  eBillingStep,
} from "../../../../context/BillingContext";

export default function PayAndSubscribe() {
  const [clientSecret, setClientSecret] = useState<string>("");
  const { createIntent } = usePayment();
  const { generateBillingPortalUrl } = useCustomer();
  const [isLoadingSubscription, setIsLoadingSubscription] =
    useState<boolean>(false);
  const [subscriptionStatus, setSubscriptionStatus] =
    useState<eSubscriptionStatus>(eSubscriptionStatus.NOT_PROCESSED);
  const [billingPortalUrl, setBillingPortalUrl] = useState<string>("");
  const [showSecureBar, setShowDarkBar] = useState<boolean>(true);
  const { createNewSubscription } = useSubscription();
  const { setStep, selectedPlan } = useBillingContext();
  const history = useHistory();

  useEffect(() => {
    async function loadSetupIntent() {
      const intent = await createIntent();

      if (intent) {
        setClientSecret(intent.client_secret);
      }
    }

    loadSetupIntent();
    localStorage.removeItem("is_premium_valid");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function createSubscription() {
    setIsLoadingSubscription(true);

    const subStatus = await createNewSubscription({
      planIdentifier: selectedPlan.identifier,
      priceId: String(selectedPlan.priceId),
    });
    setSubscriptionStatus(subStatus);

    //Fullfill the billing portal url
    if (subStatus === eSubscriptionStatus.ALREADY_EXISTS) {
      await fillBillingPortal();
    }
    // Hide secure bar on success  and show all done bar
    else if (subStatus === eSubscriptionStatus.CREATED) {
      setShowDarkBar(false);
    }

    setIsLoadingSubscription(false);
  }

  async function fillBillingPortal() {
    const url = await generateBillingPortalUrl();

    if (url) {
      setBillingPortalUrl(url);
    }
  }

  function getPrincipalContainer() {
    if (isLoadingSubscription) {
      return <LoadingSubscription />;
    } else if (subscriptionStatus === eSubscriptionStatus.ALREADY_EXISTS) {
      return (
        <FailedSubscription
          text="Você já tem uma assinatura ativa em sua conta, para ativar outra assinatura você precisa cancelar sua assinatura atual."
          actionText="Gerenciar assinatura"
          actionUrl={billingPortalUrl}
          isActionLoading={billingPortalUrl.length === 0}
          canGoDashboard={true}
        />
      );
    } else if (subscriptionStatus === eSubscriptionStatus.UNKNOWN_ERROR) {
      return (
        <FailedSubscription
          text="Ocorreu um erro desconhecido ao processar sua assinatura, por favor, tente novamente."
          actionText="Tentar novamente"
          actionUrl={"/"}
          actionFunction={createSubscription}
          isActionLoading={false}
          canGoDashboard={false}
        />
      );
    } else if (subscriptionStatus === eSubscriptionStatus.CREATED) {
      return <SuccessfullySubscription />;
    } else if (subscriptionStatus === eSubscriptionStatus.PAYMENT_FAILED) {
      return (
        <FailedSubscription
          text="Houve um erro com seu método de pagamento, por favor, verifique se as informações estão corretas e há limite suficiente."
          actionText="Voltar"
          actionUrl={"/billing"}
          actionFunction={() => {
            setStep(eBillingStep.CREATE_CUSTOMER);
          }}
          isActionLoading={false}
          canGoDashboard={false}
        />
      );
    }

    return (
      <div className="container my-auto py-4">
        <div className="row">
          <div className="col-11 col-lg-10 mx-auto">
            <h3 className="text-black text-center mb-3 ">
              Método de pagamento
            </h3>

            {clientSecret ? (
              <Elements options={{ clientSecret }} stripe={stripePromise}>
                <CheckoutForm
                  clientSecret={clientSecret}
                  callOnFinish={createSubscription}
                />
              </Elements>
            ) : (
              <div className="centered-flex mg-b-20 mg-t-20">
                <Spinner animation="border" />
              </div>
            )}

            <p className="text-2 text-center text-black mb-0">
              <span className="mx-1">
                <Link
                  to="/"
                  onClick={(e) => {
                    e.preventDefault();
                    // Remove planId from URL
                    const newUrl = window.location.pathname;
                    history.push(newUrl);

                    setStep(eBillingStep.PLAN);
                  }}
                >
                  Voltar
                </Link>
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Modal size="lg" fullscreen={true} show={true}>
        <div className="bg-dark">
          <div className="container">
            <div className="row">
              {subscriptionStatus !== eSubscriptionStatus.CREATED && (
                <div className="col-lg-4 shadow-lg">
                  <div className="hero-wrap d-flex align-items-center rounded-3 rounded-end-0 h-100">
                    <div className="hero-mask opacity-9 bg-primary" />
                    <div className="hero-bg hero-bg-scroll" />
                    <div className="hero-content mx-auto w-100 h-100 d-flex flex-column">
                      <div className="row g-0">
                        <div className="col-11 col-lg-10 mx-auto">
                          <div className="mt-3">{projectLogoLight}</div>
                        </div>
                      </div>
                      <div
                        className={isMobile ? "row g-0 my-3" : "row g-0 my-4"}
                      >
                        <div className="col-11 col-lg-10 mx-auto">
                          {showSecureBar ? (
                            <h1
                              className="text-11"
                              style={{ color: "#e0e0e0" }}
                            >
                              Falta{" "}
                              <span className="markText-animation">pouco.</span>
                            </h1>
                          ) : (
                            <h1
                              className="text-11"
                              style={{ color: "#e0e0e0" }}
                            >
                              Agora você é{" "}
                              <span className="markText-animation">fato.</span>
                            </h1>
                          )}

                          {showSecureBar && (
                            <p
                              className="text-5 lh-base mb-4"
                              style={{ color: "#e0e0e0" }}
                            >
                              Seus dados são protegidos com criptografia e
                              segurança de ponta a ponta.
                            </p>
                          )}

                          <article className="d-none d-lg-flex align-items-center justify-content-center">
                            {showSecureBar && <BsShieldCheck size={100} />}
                          </article>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div
                className={
                  "shadow-lg d-flex align-items-center rounded-3 rounded-start-0" +
                  (subscriptionStatus === eSubscriptionStatus.CREATED
                    ? " col-lg-12"
                    : " col-lg-8")
                }
                style={{
                  backgroundColor: "white",
                  borderRadius: 10,
                }}
              >
                {getPrincipalContainer()}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}